import { useTheme } from "@emotion/react";
import { tokens } from "../theme";
import { ResponsiveLine } from "@nivo/line";
import { Label } from "@mui/icons-material";
import { useState } from "react";

const LineChart3Param = ({ dataPayload, isDashboard = false }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const transformData = (payload) => {
    return [
      {
        id: "DO_value",
        color: tokens("dark").greenAccent[300],
        data: payload?.DO_value
          ? payload.DO_value.map((item) => ({
              x: item.time || "N/A",
              y: item.value ?? 0,
              Label: item.time || "N/A",
            }))
          : [],
      },
      {
        id: "pH_value",
        color: tokens("dark").redAccent[300],
        data: payload?.pH_value
          ? payload.pH_value.map((item) => ({
              x: item.time || "N/A",
              y: item.value ?? 0,
            }))
          : [],
      },
      {
        id: "temp",
        color: tokens("dark").blueAccent[300],
        data: payload?.temp
          ? payload.temp.map((item) => ({
              x: item.time || "N/A",
              y: item.value ?? 0,
            }))
          : [],
      },
    ];
  };

  const chartData = transformData(dataPayload);
  const [visibility, setVisibility] = useState({
    DO_value: true,
    pH_value: true,
    temp: true,
  });

  const toggleVisibility = (id) => {
    console.log(visibility);
    setVisibility((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };

  // Filter data based on visibility
  const filteredData = chartData.filter((serie) => visibility[serie.id]);
  //   console.log(chartData);

  return (
    <ResponsiveLine
      data={chartData}
      theme={{
        axis: {
          domain: {
            line: {
              stoke: colors.grey[100],
            },
          },
          legend: {
            text: {
              fill: colors.grey[200],
            },
          },
          ticks: {
            line: {
              stroke: colors.grey[100],
              strokeWidrh: 1,
            },
            text: {
              fill: colors.grey[200],
            },
          },
        },
        legends: {
          text: {
            fill: colors.grey[200],
          },
        },
      }}
      colors={isDashboard ? { datum: "color" } : { scheme: "nivo" }}
      margin={{ top: 50, right: 110, bottom: 50, left: 60 }}
      xScale={{ type: "point" }}
      yScale={{
        type: "linear",
        min: "auto",
        max: "auto",
        stacked: true,
        reverse: false,
      }}
      yFormat=" >-.2f"
      curve="cardinal"
      axisTop={null}
      axisRight={null}
      axisBottom={{
        tickSize: 5,
        tickPadding: 5,
        tickRotation: 0,
        legend: isDashboard ? undefined : "transportation",
        legendOffset: 36,
        legendPosition: "middle",
        truncateTickAt: 0,
      }}
      axisLeft={{
        tickSize: 5,
        tickPadding: 5,
        tickRotation: 0,
        legend: isDashboard ? undefined : "Value",
        legendOffset: -40,
        legendPosition: "middle",
        truncateTickAt: 0,
      }}
      enableGridX={false}
      enableGridY={false}
      pointSize={10}
      pointColor={{ theme: "background" }}
      pointBorderWidth={2}
      pointBorderColor={{ from: "serieColor" }}
      pointLabel="data.yFormatted"
      enableArea={true}
      pointLabelYOffset={-12}
      enableTouchCrosshair={true}
      useMesh={true}
      tooltip={({ point }) => (
        <div
          style={{
            background: "white",
            padding: "5px",
            border: `1px solid ${point.serieColor}`,
            borderRadius: "5px",
            color: "black",
          }}
        >
          <strong>{point.serieId}</strong>
          <br />
          Time: {point.data.x}
          <br />
          Value: {point.data.y}
        </div>
      )}
      legends={[
        {
          anchor: "bottom-right",
          direction: "column",
          justify: false,
          translateX: 100,
          translateY: 0,
          itemsSpacing: 0,
          itemDirection: "left-to-right",
          itemWidth: 80,
          itemHeight: 20,
          itemOpacity: 0.75,
          symbolSize: 12,
          symbolShape: "circle",
          symbolBorderColor: "rgba(0, 0, 0, .5)",
          onClick: (data) => toggleVisibility(data.id),
          effects: [
            {
              on: "hover",
              style: {
                itemBackground: "rgba(0, 0, 0, .03)",
                itemOpacity: 1,
              },
            },
          ],
        },
      ]}
    />
  );
};

export default LineChart3Param;
